module.exports = __webpack_public_path__ + "img/mk-思想政治@2x.6383aa26.png";